import React, { FC, useMemo } from 'react';

import cn from 'classnames';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../../../../../init-store';
import { Button, SvgImage } from '../../../../../../shared/components';
import { ButtonProps } from '../../../../../../shared/components/button';
import Spin from '../../../../../../shared/components/spin';
import { i18n } from '../../../../../../shared/helpers/i18n';
import { isSidebarVisible } from '../../../../selectors';
import { CollapseBreakpoint } from '../../../toolbar/constants';
import { getIsChatLoading } from '../../slice';
import classes from './style.css';

type Props = {
    buttonSize: ButtonProps['size'];
    onClick: () => void;
    disabled?: boolean;
    chatMessagesCount?: number;
    buttonProps?: ButtonProps[];
    collapseBreakpoint?: CollapseBreakpoint;
};
const mapStateToProps = (state: RootState) => {
    return {
        isLoading: getIsChatLoading(state),
        isSidebarVisible: isSidebarVisible(state),
    };
};

const connector = connect(mapStateToProps);
const ChatButton: FC<Props & ConnectedProps<typeof connector>> = ({
    isLoading,
    chatMessagesCount,
    disabled,
    buttonSize,
    onClick,
    buttonProps,
    isSidebarVisible,
    collapseBreakpoint = CollapseBreakpoint.DEFAULT,
}) => {
    const chatIcon = useMemo(() => {
        return (
            <>
                {isLoading ? (
                    <Spin size="md" color="white" progress />
                ) : (
                    <SvgImage
                        imageName="chat"
                        className={classes.chatIcon}
                        style={{
                            width: 25,
                            height: 25,
                        }}
                    />
                )}
                {!!chatMessagesCount && (
                    <div className={classes.badge}>
                        <div className={classes.badgeText}>{chatMessagesCount > 99 ? '99+' : chatMessagesCount}</div>
                    </div>
                )}
            </>
        );
    }, [isLoading, chatMessagesCount]);

    const buttonClasses = cn(
        classes.chatButton,
        {
            [classes.isSidebarVisible]: isSidebarVisible,
            [classes.isDisabled]: disabled,
            [classes.collapsible]: collapseBreakpoint,
        },
        collapseBreakpoint && classes[collapseBreakpoint]
    );

    return (
        <div className={classes.buttonContainer}>
            <Button
                title={i18n('toolbar', 'chat-button-alt-title')}
                className={buttonClasses}
                view="neutral"
                size={buttonSize}
                onClick={onClick}
                isDisabled={disabled}
                testId="chat-alt-button"
                icon={chatIcon}
                {...buttonProps}
            >
                <span className={classes.chatText}>{i18n('toolbar', 'chat-button-title')}</span>
            </Button>
        </div>
    );
};
export default connector(ChatButton);
